import axios from 'axios';
import history from './history';
import _ from 'lodash';
import { START_LOADING, END_LOADING } from './loadingActions'
import { RESET_CLIENT } from './admin'
import jwt_decode from 'jwt-decode'
import Echo from 'laravel-echo'
import { reset } from 'redux-form'

export const FETCH_MODELS = "fetch_models";
export const FETCH_CASOS = "fetch_casos";
export const FETCH_USER = "fetch_user";
export const FETCH_USERS = "fetch_users";
export const AUTH_USER = "auth_user";
export const UNAUTH_USER = "unauth_user";
export const AUTH_ERROR = "auth_error";
export const REMOVE_CASO = "remove_caso";
export const UPDATE_CASO = "update_caso";
export const FETCH_COMMENTS = "fetch_comments";
export const FETCH_ALL_COMMENTS = "fetch_all_comments";
export const ADD_COMMENT = "add_comment";
export const ADD_ADDRESS = "add_address";
export const SHOW_NOTIFY  = "show_notify";
export const GET_NOTIFICATIONS  = "get_notifications";
export const ADD_NOTIFICATION  = "add_notification";
export const FETCH_STEPS  = "fetch_steps";
export const UPDATE_STEPS  = "update_steps";

axios.interceptors.request.use((config)=>{
    const token = localStorage.getItem("token");
    config.headers.Authorization = `Bearer ${token}`;
    return config;
})

export function checkAndRefresh(dispatch) {
    const token = localStorage.getItem('token');
    let dateNow = new Date().getTime();
    return new Promise((resolve, reject) => {
        if (jwt_decode(token).exp < (dateNow / 1000) + (60*15)) {
            axios.get(`/api/auth/refresh`).then(response => {
                resolve(response.data.result.token)
                localStorage.setItem('token', response.data.result.token);
            }).catch(error => {
                reject(error)
                fetchError( dispatch, error )
            })
        } else {
            resolve(token)
        }
    });
}
export function singInUser({email, password}) {
    return function(dispatch){
        axios.post(`/api/auth/login`, {email, password}).then( response  => {
            if(response.data.response === "success"){
                let token = response.data.result.token;
                localStorage.setItem('token', token);
                dispatch({ type: AUTH_USER });
                dispatch(reset('signin'));
                if(response.data.result.admin == 1){
                    history.push('/admin/dashboard');
                }else{
                    history.push('/dashboard');
                }
                //if(!window.Echo){
                    window.Echo = new Echo({
                        broadcaster: 'socket.io',
                        host: window.location.hostname + ':6001',
                        auth: {
                            headers: {
                                'Authorization': 'Bearer ' + token
                            }
                        }
                    });
                //}
                const userId = jwt_decode(token).sub;
                window.Echo.private('App.User.' + userId)
                    .notification((e) => {
                        console.log(e);
                        if(e){
                            dispatch({
                                type: SHOW_NOTIFY,
                                payload: {
                                    message: e
                                }
                            })
                            dispatch({
                                type: SHOW_NOTIFY,
                                payload: {}
                            })
                            if(e.comment && window.location.pathname === "/casos/" + e.comment.caso_id){
                                dispatch({
                                    type: ADD_COMMENT,
                                    payload: e.comment
                                })
                            }
                        };
                    });
            }else{
                dispatch(authError("Email o password incorrectos"));
            }
        }).catch(error=>{
            dispatch(authError("Hubo un problema de conexión por favor intenta de nuevo"));
        });
    }
}
export function singOutUser() {
    localStorage.removeItem('token');
    return function(dispatch) {
        dispatch({
            type: UNAUTH_USER
        });
        dispatch({
            type: RESET_CLIENT
        })
    }
}
export function singUpUser() {
    return function(dispatch) {
        axios.post(`/api/user/new`, data).then(response => {
            history.push('/');
        }).catch(error => {
            fetchError( dispatch, error )
        });
    }
}
export function addClient(data) {
    return function(dispatch) {
        axios.post(`/api/clients/new`, data).then(response => {
            history.push('/admin/clients');
        }).catch(error => {
            fetchError( dispatch, error )
        });
    }
}

export function authError(error){
    return{
        type: AUTH_ERROR,
        payload: error
    }
}

export function fetchError(dispatch, error){
    if(error.response && error.response.status === 401){
        singOutUser()
        dispatch({
            type: UNAUTH_USER,
        })
        dispatch({
            type: AUTH_ERROR,
            payload: error.response.message
        })
    }
}
export function fetchModels(id) {
    return function(dispatch) {
        axios.get(`/api/casos/${id}`).then(response => {
            dispatch({
                type: FETCH_MODELS,
                payload: _.omit(response.data, 'comments')
            });
            dispatch({
                type: FETCH_COMMENTS,
                payload: response.data.comments
            });
        }).catch(error => {
            fetchError( dispatch, error )
        });
    }
}
export function fetchCasos(sort, order, q, page, filter, archived, user, view){
    return function(dispatch) {
        let params = "";
        if(sort){
            params = `?sort=${sort}`
        }
        if(order){
            params += `&order=${order}`
        }
        if(q){
            params += `&q=${q}`
        }
        if(page){
            params += `&page=${page}`
        }
        if(filter){
            params += `&filter=${filter}`
        }
        if(archived){
            params += `&archived=${archived}`
        }
        if(user){
            params += `&user=${user}`
        }
        if(view){
            params += `?view=${view}`
        }
        axios.get(`/api/casos${params}`).then(response => {
            dispatch({
                type: FETCH_CASOS,
                payload: response
            });
        }).catch(error => {
            fetchError( dispatch, error )
        });
    }
}
export function emptyCasos() {
    return{
        type: FETCH_CASOS,
        payload: {data:{}}
    };
}
export function fetchUser() {
    return function(dispatch){
        checkAndRefresh(dispatch).then((newToken)=>{
            axios.get(`/api/user`).then( response  => {
                dispatch({
                    type: FETCH_USER,
                    payload: response
                });
                dispatch({
                    type: GET_NOTIFICATIONS,
                    payload: response.data.result.notifications
                });
            }).catch(error=>{
                fetchError( dispatch, error )
            });
        })
    }
}

export function deleteUser(user) {
    return function(dispatch){
        checkAndRefresh(dispatch).then((newToken)=>{
            axios.delete(`/api/clients/${user}`).then( response  => {
                dispatch({
                    type: FETCH_USERS,
                    payload: response
                });
            }).catch(error=>{
                fetchError( dispatch, error )
            });
        })
    }
}

export function newCaso(data, clientId) {
    return function(dispatch) {
        dispatch({
            type: START_LOADING
        })
        axios.post(`/api/casos/new`, data).then(response => {
            dispatch(reset('wizard'));
            dispatch({
                type: END_LOADING
            })
            if(clientId){
                history.push(`/admin/clients/${clientId}`);
            }else{
                history.push('/casos');
            }
        }).catch(error => {
            fetchError( dispatch, error )
        });
    }
}
export function removeCaso(id) {
    return function(dispatch) {
        axios.delete(`/api/casos/${id}`).then(response => {
            dispatch({
                type: FETCH_CASOS,
                payload: response
            });
        }).catch(error => {
            fetchError( dispatch, error )
        });
    }
}
export function addModelos(data) {
    return function(dispatch) {
        axios.post(`/api/modelo/new`, data).then(response => {
            history.push('/');
        }).catch(error => {
            fetchError( dispatch, error )
        });
    }
}
export function addComment(data) {
    return function(dispatch) {
        axios.post(`/api/comments/new`, data).then(response => {
            dispatch({
                type: ADD_COMMENT,
                payload: response.data
            })
            dispatch({
                type: END_LOADING
            })
        }).catch(error => {
            fetchError( dispatch, error )
        });
    }
}
export function emptyComments() {
    return {
        type: FETCH_COMMENTS,
        payload: {}
    }
}
export function fetchComments() {
    return function(dispatch) {
        axios.get(`/api/comments`).then(response => {
            dispatch({
                type: FETCH_COMMENTS,
                payload: response.data
            })

        }).catch(error => {
            fetchError( dispatch, error )
        });
    }
}
export function addAddress(data, clientId) {
    if(clientId) data.clientId = clientId;
    return function(dispatch) {
        axios.post(`/api/address/new`, data).then(response => {
            dispatch({
                type: ADD_ADDRESS,
                payload: response
            })
            dispatch({
                type: END_LOADING
            })
            dispatch(reset('addAddress'))
        }).catch(error => {
            fetchError( dispatch, error )
        });
    }
}
export function updateCaso(data) {
    return function(dispatch) {
        checkAndRefresh(dispatch).then((newToken) => {
            dispatch({
                type: START_LOADING
            })
            axios.patch(`/api/casos/${data.id}/update`, data).then(response => {
                dispatch({
                    type: FETCH_MODELS,
                    payload: _.omit(response.data, 'comments')
                })
                dispatch({
                    type: END_LOADING
                })
            }).catch(error => {
                dispatch({
                    type: END_LOADING
                })
                fetchError(dispatch, error)
            });
        })
    }
}
export function markAllNotifications() {
    return function(dispatch) {
        checkAndRefresh(dispatch).then((newToken) => {
            axios.post(`/api/user/markAllNotifications`).then(response => {
                dispatch({
                    type: GET_NOTIFICATIONS,
                    payload: {}
                })
            }).catch(error => {
                fetchError(dispatch, error)
            });
        })
    }
}

export function fetchUsers(sort, order, q, page, showApproved) {
    return function(dispatch){
        checkAndRefresh(dispatch).then((newToken)=>{
            let params = "";
            if(sort){
                params = `?sort=${sort}`
            }
            if(order){
                params += `&order=${order}`
            }
            if(q){
                params += `&q=${q}`
            }
            if(page){
                params += `&page=${page}`
            }
            if(showApproved){
                params += `&showApproved=${showApproved}`
            }
            axios.get(`/api/clients${params}`).then( response  => {
                dispatch({
                    type: FETCH_USERS,
                    payload: response
                });
            }).catch(error=>{
                fetchError( dispatch, error )
            });
        })
    }
}
export function adminModels(body){
    return function(dispatch){
        checkAndRefresh(dispatch).then((newToken)=>{
            dispatch({
                type: START_LOADING
            })
            axios.post(`/api/modelo/new`, body).then(response => {
                dispatch({
                    type: FETCH_MODELS,
                    payload: _.omit(response.data, 'comments')
                });
                dispatch({
                    type: END_LOADING
                })
                history.push(`/casos/${response.data.id}/#viewport`);
                location.reload()
            }).catch(error => {
                dispatch({
                    type: END_LOADING
                })
                fetchError( dispatch, error )
            });
        })
    }
}
export function fetchSteps(casoId){
    return function(dispatch){
        checkAndRefresh(dispatch).then((newToken)=>{
            dispatch({
                type: START_LOADING
            })
            axios.get(`/api/steps/${casoId}`).then(response => {
                dispatch({
                    type: FETCH_STEPS,
                    payload: response.data
                });
                dispatch({
                    type: END_LOADING
                })
            }).catch(error => {
                dispatch({
                    type: END_LOADING
                })
                fetchError( dispatch, error )
            });
        })
    }
}
export function updateSteps(body, casoId){
    return function(dispatch){
        checkAndRefresh(dispatch).then((newToken)=>{
            dispatch({
                type: START_LOADING
            })
            axios.patch(`/api/steps/${casoId}`, body).then(response => {
                dispatch({
                    type: UPDATE_STEPS,
                    payload: response.data
                });
                dispatch({
                    type: END_LOADING
                })
            }).catch(error => {
                dispatch({
                    type: END_LOADING
                })
                fetchError( dispatch, error )
            });
        })
    }
}
export function addNotification(data) {
    return function(dispatch) {
        dispatch({
            type: ADD_NOTIFICATION,
            payload: data
        })
    }
}
export function uploadAvatar(data, userId){
    return function(dispatch){
        checkAndRefresh(dispatch).then((newToken)=>{
            dispatch({
                type: START_LOADING
            })
            axios.post(`/api/user/${userId}/avatar`, data).then(response => {
                dispatch({
                    type: FETCH_USER,
                    payload: response
                });
                dispatch({
                    type: END_LOADING
                })
            }).catch(error => {
                dispatch({
                    type: END_LOADING
                })
                fetchError( dispatch, error )
            });
        })
    }
}
export function downloadAttachment(attachment){
    window.open(`/api/download/${attachment}?token=${localStorage.getItem("token")}`,'download');
}
export function showAttachment(attachment){
    var attch = window.open('', `attachment_${attachment}`);
    attch.document.write('<span style="font-family: Arial; font-size: 14px;">Cargando adjunto...</span>');
    return function(dispatch){
        checkAndRefresh(dispatch).then((newToken)=>{
            dispatch({
                type: START_LOADING
            })
            axios.get(`/api/attachment/${attachment}`).then(response => {
                attch.location.href= response.data.url;
                dispatch({
                    type: FETCH_MODELS,
                    payload: _.omit(response.data.caso, 'comments')
                });
                dispatch({
                    type: END_LOADING
                })
            }).catch(error => {
                dispatch({
                    type: END_LOADING
                })
                fetchError( dispatch, error )
            });
        })
    }
}
export function uploadAttachment(data){
    return function(dispatch){
        checkAndRefresh(dispatch).then((newToken)=>{
            dispatch({
                type: START_LOADING
            })
            axios.post(`/api/attachments`, data).then(response => {
                dispatch({
                    type: FETCH_MODELS,
                    payload: _.omit(response.data, 'comments')
                });
                dispatch({
                    type: END_LOADING
                })
            }).catch(error => {
                dispatch({
                    type: END_LOADING
                })
                fetchError( dispatch, error )
            });
        })
    }
}
export function deleteAttachment(url){
    return function(dispatch){
        checkAndRefresh(dispatch).then((newToken)=>{
            dispatch({
                type: START_LOADING
            })
            axios.delete(`/api/attachment/${url}`).then(response => {
                dispatch({
                    type: FETCH_MODELS,
                    payload: _.omit(response.data, 'comments')
                });
                dispatch({
                    type: END_LOADING
                })
            }).catch(error => {
                dispatch({
                    type: END_LOADING
                })
                fetchError( dispatch, error )
            });
        })
    }
}
export function updateUser(data, userId){
    return function(dispatch){
        checkAndRefresh(dispatch).then((newToken)=>{
            dispatch({
                type: START_LOADING
            })
            axios.patch(`/api/user/${userId}`, data).then(response => {
                dispatch({
                    type: FETCH_USER,
                    payload: response
                });
                dispatch({
                    type: END_LOADING
                })
            }).catch(error => {
                dispatch({
                    type: END_LOADING
                })
                fetchError( dispatch, error )
            });
        })
    }
}
export function updateAddress(data, addrId){
    return function(dispatch){
        checkAndRefresh(dispatch).then((newToken)=>{
            dispatch({
                type: START_LOADING
            })
            axios.patch(`/api/address/${addrId}`, data).then(response => {
                dispatch({
                    type: FETCH_USER,
                    payload: response
                });
                dispatch({
                    type: END_LOADING
                })
            }).catch(error => {
                dispatch({
                    type: END_LOADING
                })
                fetchError( dispatch, error )
            });
        })
    }
}
export function favAddress(data, addrId){
    return function(dispatch){
        checkAndRefresh(dispatch).then((newToken)=>{
            dispatch({
                type: START_LOADING
            })
            axios.patch(`/api/address/${addrId}/fav`, data).then(response => {
                dispatch({
                    type: FETCH_USER,
                    payload: response
                });
                dispatch({
                    type: END_LOADING
                })
            }).catch(error => {
                dispatch({
                    type: END_LOADING
                })
                fetchError( dispatch, error )
            });
        })
    }
}
export function removeAddress(addrId){
    return function(dispatch){
        checkAndRefresh(dispatch).then((newToken)=>{
            dispatch({
                type: START_LOADING
            })
            axios.delete(`/api/address/${addrId}`).then(response => {
                dispatch({
                    type: FETCH_USER,
                    payload: response
                });
                dispatch({
                    type: END_LOADING
                })
            }).catch(error => {
                dispatch({
                    type: END_LOADING
                })
                fetchError( dispatch, error )
            });
        })
    }
}
export function changePassword(data){
    return function(dispatch){
        checkAndRefresh(dispatch).then((newToken)=>{
            dispatch({
                type: START_LOADING
            })
            axios.post(`/api/auth/changePassword`, data).then(response => {
                dispatch({
                    type: END_LOADING
                })
            }).catch(error => {
                dispatch({
                    type: END_LOADING
                })
                fetchError( dispatch, error )
            });
        })
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/actions/index.js